import { api } from './api';

export type WorkspaceAccessSourceType = 'user' | 'role' | 'team';
export type WorkspaceAccessActionType = 'allow' | 'deny';

export interface WorkspaceAccessRuleDto {
  id: string;
  workspaceId: string;
  sourceType: string;
  sourceId: string;
  action: string;
  createdAt: string;
  createdBy?: string | null;
}

export interface AddWorkspaceAccessBody {
  sourceType: WorkspaceAccessSourceType;
  sourceId: string;
  action: WorkspaceAccessActionType;
}

class WorkspaceAccessService {
  async listByWorkspace(workspaceId: string): Promise<WorkspaceAccessRuleDto[]> {
    const response = await api.get<WorkspaceAccessRuleDto[]>(`/workspaces/${workspaceId}/access`);
    const raw = response.data;
    return Array.isArray(raw) ? raw : [];
  }

  async addRule(workspaceId: string, body: AddWorkspaceAccessBody): Promise<WorkspaceAccessRuleDto> {
    const response = await api.post<WorkspaceAccessRuleDto>(`/workspaces/${workspaceId}/access`, {
      sourceType: body.sourceType,
      sourceId: body.sourceId,
      action: body.action,
    });
    return response.data;
  }

  async removeRule(workspaceId: string, accessId: string): Promise<void> {
    await api.delete(`/workspaces/${workspaceId}/access/${accessId}`);
  }
}

export const workspaceAccessService = new WorkspaceAccessService();
